export default {

    methods: {
        transferValue2Desc(statusList, value) {
            let desc = '';
            statusList.forEach(e => {
                if (e.value == value) {
                    desc = e.desc;
                    return;
                }
            })
            return desc;
        },

        transferValue2Description(statusList, value) {
            let desc = '';
            statusList.forEach(e => {
                if (e.value == value) {
                    desc = e.description;
                    return;
                }
            })
            return desc;
        },
    },

}